<template>
  <div
    id="inspire"
    class="h-screen"
  >
    <v-main class="fill-height">
      <v-container
        fluid
        class="fill-height"
      >
        <v-row
          align="center"
          justify="center"
          class="fill-height"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-form
              ref="form"
              @submit.prevent="register"
            >
              <v-card>
                <v-card-title class="bg-grey-lighten-4">
                  Registracija
                </v-card-title>
                <v-card-text>
                  <v-row class="mt-2">
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="ime"
                        prepend-icon="person"
                        name="ime"
                        label="Ime"
                        type="text"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        v-model="priimek"
                        prepend-icon="person"
                        name="priimek"
                        label="Priimek"
                        type="text"
                      />
                    </v-col>
                  </v-row>

                  <v-text-field
                    v-model="email"
                    prepend-icon="email"
                    name="email"
                    label="Email"
                    type="email"
                    :rules="emailRules"
                  />
                  <v-text-field
                    id="password"
                    v-model="password"
                    prepend-icon="lock"
                    name="password"
                    label="Geslo"
                    type="password"
                    :rules="passwordRules"
                  />
                  <v-text-field
                    v-model="companyName"
                    prepend-icon="work"
                    name="companyName"
                    label="Ime vašega podjetja"
                    type="text"
                    :rules="companyRules"
                  />
                  <v-text-field
                    v-model="phone"
                    prepend-icon="phone"
                    name="phone"
                    label="Telefonska številka"
                    type="text"
                    :rules="phoneRules"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    variant="outlined"
                    :loading="loading"
                    type="submit"
                  >
                    Registriraj se
                  </v-btn>
                </v-card-actions>
                <v-progress-linear
                  v-if="loading"
                  color="primary"
                  indeterminate
                />
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
  import router from '../router';

  export default {
    data: () => ({
      loading: false,
      drawer: null,
      ime: '',
      priimek: '',
      email: '',
      password: '',
      companyName: '',
      phone: '',
      lastErrorCode: ''
    }),
    computed: {
      emailRules() {
        return [
          v => !!v || 'Vnos e-pošte je obvezen',
          v => /.+@.+/.test(v) || 'Vpišite veljaven e-poštni naslov',
          v => this.lastErrorCode !== 'auth/email-already-in-use' || 'Uporabnik že registriran'
        ]
      },
      passwordRules() {
        return [
          v => !!v || 'Vpišite geslo',
          v =>
            v.length >= 6 ||
            'Geslo mora biti dolgo vsaj 6 znakov',
          v => this.lastErrorCode !== 'auth/weak-password' || 'Šibko geslo'
        ]
      },
      companyRules() {
        return [
          v => !!v || 'Vpišite ime podjetja',
          v =>
            v.length >= 2 ||
            'Ime podjetja naj bo dolgo vsaj 2 znaka',
        ]
      },
      phoneRules() {
        return [
          v => !!v || 'Vpišite telefonsko številko',
          v =>
              v.length >= 9 ||
              'Vpišite veljavno telefonsko številko',
        ]
      }
    },
    mounted() {
      this.$store.subscribe((mutation, state) => {
        if ('userLoggedIn' === mutation.type) {
          router.push({name: 'dashboard'});
        }
      })
    },
    methods: {
      async register() {
        if ((await this.$refs.form.validate()).valid) {
          this.loading = true;

          try {
            await this.$store.dispatch('registerNewUser', {
              firstName  : this.ime,
              lastName   : this.priimek,
              email      : this.email,
              password   : this.password,
              companyName: this.companyName,
              phone      : this.phone,
            });
          } catch (e) {
            this.lastErrorCode = e.code;
            await this.$refs.form.validate();
            this.lastErrorCode = '';
          }

          this.loading = false;
        }
      }
    }
  }
</script>
